export default __webpack_public_path__ + "static/media/redditDeskMobile.31b4f247.svg";